/*! @azure/msal-browser v3.10.0 2024-02-17 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
function isBridgeError(error) {
    return error.status !== undefined;
}

export { isBridgeError };
//# sourceMappingURL=BridgeError.mjs.map
